import { Box } from '@mui/material';
import React from 'react';

export function ButtonGroup({
  children,
  ...props
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row'
      }}
      {...props}
    >
      {children}
    </Box>
  )
}